import React from 'react';

import { FlexBox } from 'ml-rubiks-styleguide/src/box';
import { CircularProgress } from 'ml-rubiks-styleguide/src/circular-progress';
import { Typography } from 'ml-rubiks-styleguide/src/typography';

export interface LoadingMessageProps {
    message?: string;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const sizeMap = {
    sm: 16,
    md: 20,
    lg: 32
};

export const LoadingMessage: React.FC<LoadingMessageProps> = ({
    message,
    size = 'md',
    className = ''
}) => {
    const iconSize = sizeMap[size];
    return (
        <FlexBox vAlign="center" hAlign="center" gap={1} className={className}>
            <CircularProgress size={iconSize} />
            {message && (
                <Typography color="text.secondary">
                    {message}
                </Typography>
            )}
        </FlexBox>
    );
};
